module.exports = __webpack_public_path__ + "img/cultura4.3673181b.png";